module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-microwave-parallel.json
// module id = 819
// module chunks = 35252511437423